import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import RemoveIcon from "@mui/icons-material/Remove";

export const columnWidths = {
    status: 80,
    field: 260,
    tab: 200,
    row: 120,
    rule: 340,
};

export const getValidationStatus = (valid) => {
    if (valid === 'N/A') return 'na';
    return valid === true ? 'passed' : 'failed';
};

export const getCategoryStats = (items) => {
    const failed = items.filter(i => getValidationStatus(i.passed) === 'failed').length;
    const na = items.filter(i => getValidationStatus(i.passed) === 'na').length;
    const total = items.length;
    const applicable = total - na;
    const passed = applicable - failed;
    return { failed, passed, na, total, applicable, allPassed: failed === 0 };
};

export const getCategoryColor = (theme, failed) => (failed > 0 ? theme.palette.jigsaw.red : theme.palette.jigsaw.success);

export const getStatusIcon = (status) => {
    switch (status) {
        case 'passed':
            return <CheckIcon fontSize="small" />;
        case 'failed':
            return <ClearIcon fontSize="small" />;
        case 'na':
            return <RemoveIcon fontSize="small" />;
        default:
            return <ClearIcon fontSize="small" />;
    }
};

export const getStatusColor = (theme, status) => {
    switch (status) {
        case 'passed':
            return theme.palette.jigsaw.success;
        case 'failed':
            return theme.palette.jigsaw.red;
        case 'na':
            return theme.palette.grey[500];
        default:
            return theme.palette.jigsaw.red;
    }
};

export const groupByCategory = (data) => {
    const groups = {};
    data.forEach(item => {
        if (!groups[item.category]) groups[item.category] = [];
        groups[item.category].push(item);
    });
    return groups;
};

export const processValidationData = (validationData) => {
    // console.log('validationData in processValidationData', validationData);
    if (!validationData || !Array.isArray(validationData)) {
        return [];
    }
    
    // Check if we have nested structure (array of categories with results)
    if (validationData.length > 0 && validationData[0].results) {
        // Handle nested structure from network response
        const output = validationData.flatMap(categoryData => 
            (categoryData.results || []).map(result => ({
                category: categoryData.category,
                field_name: result.field_name,
                tab: result.tab,
                line: result.line,
                rule: result.rule,
                passed: result.passed
            }))
        );
        // console.log('output in processValidationData', output);
        return output;
    }
    
    // Handle flat structure (already processed) - this is what we're getting
    if (validationData.length > 0 && validationData[0].field_name) {
        const output = validationData.map(item => ({
            category: item.category,
            field_name: item.field_name,
            tab: item.tab,
            line: item.line || item.row,
            rule: item.rule,
            passed: item.passed
        }));
        // console.log('output in processValidationData', output);
        return output;
    }

    return [];
};
